import type { ScheduledScreenshotWatcher } from './ScheduledScreenshotWatcher';
import type { PavilionCoordinator } from '../pavilion/PavilionCoordinator';
import { machineIdState } from '../../api/stores/shared';
import { serviceContainer } from '../../services/ServiceContainer';
import { websocket, HostMessageType, type WatcherResult } from '@playcastdotio/Messaging';

function reportCheck(machineId: string, result: WatcherResult): void {
  serviceContainer.realtimeService.sendMessage(
    websocket.generators.host(HostMessageType.HOST_SCHEDULED_WATCHER_CHECK_REPORT, {
      machineId, ...result, checkedAt: Date.now(),
    }),
  );
}

/**
 * Wires ScheduledScreenshotWatcher events to realtime-api reporting.
 * Every check result (pass, mismatch, error) is reported; a mismatch also
 * triggers the restart and its restart report.
 */
export function wireScheduledWatcherEvents(
  watcher: ScheduledScreenshotWatcher,
  pavilion: PavilionCoordinator,
): void {
  watcher.events.watcherMismatchDetected.addListener((result) => {
    console.log('[Coordinators] Scheduled watcher mismatch detected — triggering restart', result);
    pavilion.handleWatcherMismatch(result.campaignId);

    const machineId = machineIdState.currentState;
    if (!machineId) return;
    serviceContainer.realtimeService.sendMessage(
      websocket.generators.host(HostMessageType.HOST_SCHEDULED_WATCHER_RESTART_REPORT, {
        machineId, ...result, restartedAt: Date.now(),
      }),
    );
    reportCheck(machineId, result);
  });

  watcher.events.watcherCheckPassed.addListener((result) => {
    const machineId = machineIdState.currentState;
    if (machineId) reportCheck(machineId, result);
  });

  watcher.events.watcherCheckErrored.addListener((result) => {
    const machineId = machineIdState.currentState;
    if (machineId) reportCheck(machineId, result);
  });
}
